import React from "react";
import './CardEstadistica.scss'
import flechaArriba from '../../../assets/icons/flecha_arriba.svg'

const CardEstadistica = ({ titulo = 'Gross Profit Margin', total = 100, completadas = 60 }) => {
    return (
        <div className="CardEstadistica">
            <div className="titulo">{titulo}</div>
            <div className="container-card">
                <div className="completadas">{completadas}</div>
                <div className="total">/</div>
                <div className="total">{total}</div>
                <div className="porcentajes">
                    <div className="cont">
                        <img src={flechaArriba} alt="" />
                        <div className="porcentaje">{Number((completadas / total) * 100).toFixed(1)} %</div>
                    </div>
                </div>
            </div>
            <div className="progress-container">
                <div className="progress-bar" style={{ width: `${(completadas / total) * 100}%` }}>
                    {/* {(completadas / total) * 100}% */}
                </div>
            </div>
        </div>
    )
}
export default CardEstadistica